export const USER_VALIDATIONS = {
  USER_NAME: { MAX_LENGTH: 20 },
  EMAIL: { MAX_LENGTH: 50 },
  BALANCE: { INT: 6, DEC: 2 },
  CREDIT: { INT: 6, DEC: 2 },
};

export const USER_AGENT = 'Agents';

export const TYPES_USER_PERMISSIONS = {
  ADMIN: 'admin',
  AGENT: 'agent',
  CASHDESK: 'cashdesk',
  COLLABORATOR_AGENT: 'collaboratorAgent',
  COLLABORATOR_OPERATOR: 'collaboratorOperator',
};

export const OPTION_STATUS = [
  {
    value: true,
    label: 'words.active',
  },
  {
    value: false,
    label: 'words.inactive',
  },
];

export const USER_EXCLUDED_TYPE = ['collaboratorAgent', 'agent'];

export const OPTION_LOCKED_STATUS = [
  { label: 'words.yes', value: true },
  { label: 'words.no', value: false },
];

export const ROUTE_USER_MANAGEMENT = {
  USER: '/user-management/users',
  AGENT: '/user-management/agents',
  VERIFICATION_REQUESTS: '/players/verification-request',
};

export const MAX_ALLOWED_USER_CURRENCIES = 8;

export const VERIFICATION_STATUS = {
  PENDING: 'pending',
  VERIFIED: 'verified',
  REJECTED: 'rejected',
};

export const VERIFICATION_MODAL = {
  MIN_ZOOM: 0.5,
  MAX_ZOOM: 3,
  ZOOM_STEP: 0.25,
  DEFAULT_ZOOM: 1,
  HISTORY_TAB: 2,
  TRANSLATE_PREFIX: 'players.verificationRequest',
};

export const OPTION_TYPE_ROLE_DATE = [
  {
    value: 'createdAt',
    label: 'tools.ipAddressRestriction.creationDate',
  },
  {
    value: 'updatedAt',
    label: 'tools.ipAddressRestriction.updateDate',
  },
];
